// extracted by mini-css-extract-plugin
export var animationContainer = "_g6-0";
export var asteriskIcon = "_g6-8";
export var conversationLeftSection = "_g6-4";
export var conversationListItem = "_g6-3";
export var conversationMiddleSection = "_g6-5";
export var conversationRightSection = "_g6-6";
export var detailsContent = "_g6-1";
export var listContainer = "_g6-7";
export var modalContent = "_g6-2";